import { useCallback, useEffect, useMemo, useState } from 'react';
import { Search, Plus, Edit3, Eye, Star } from 'lucide-react';
import api from '../api';
import { useMasterData } from '../../utils/useMasterData';

const S = `
.cl-wrap{color:#0f172a}
.cl-hero{display:flex;justify-content:space-between;gap:16px;align-items:flex-start;margin-bottom:20px;padding:20px 22px;border-radius:20px;background:linear-gradient(135deg,#eef2ff 0%,#ffffff 55%,#f8fafc 100%);border:1px solid #dbeafe;box-shadow:0 16px 40px rgba(15,23,42,.08)}
.cl-hero-copy{min-width:0}
.cl-eyebrow{display:inline-flex;align-items:center;gap:8px;padding:6px 10px;border-radius:999px;background:rgba(99,102,241,.1);color:#4338ca;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase}
.cl-title{margin:12px 0 6px;font-size:24px;font-weight:800;color:#0f172a}
.cl-subtitle{margin:0;color:#475569;font-size:14px;line-height:1.6;max-width:760px}
.cl-stats{display:grid;grid-template-columns:repeat(3,minmax(120px,1fr));gap:12px;min-width:min(100%,360px)}
.cl-stat{padding:14px 16px;border-radius:16px;background:#fff;border:1px solid #e2e8f0;box-shadow:0 10px 24px rgba(15,23,42,.06)}
.cl-stat-label{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#6366f1}
.cl-stat-value{margin-top:6px;font-size:20px;font-weight:800;color:#0f172a}
.cl-toolbar{display:flex;gap:12px;flex-wrap:wrap;align-items:center;margin-bottom:16px;padding:16px 18px;background:#fff;border:1px solid #e2e8f0;border-radius:18px;box-shadow:0 10px 30px rgba(15,23,42,.06)}
.cl-search{position:relative;flex:1;min-width:240px}
.cl-input,.cl-select{border:1px solid #cbd5e1;border-radius:12px;padding:11px 12px;background:#fff;color:#0f172a;font-size:13px;box-shadow:0 1px 2px rgba(15,23,42,.04);width:100%;min-width:0;max-width:100%;box-sizing:border-box;transition:border-color .2s ease, box-shadow .2s ease}
.cl-input{flex:1}
.cl-input:focus,.cl-select:focus{outline:none;border-color:#6366f1;box-shadow:0 0 0 4px rgba(99,102,241,.12)}
.cl-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid #4338ca;background:#4338ca;color:#fff;border-radius:12px;padding:11px 16px;font-size:13px;font-weight:700;cursor:pointer;min-height:42px;box-shadow:0 10px 24px rgba(67,56,202,.25)}
.cl-btn:disabled,.cl-ghost:disabled{opacity:.55;cursor:not-allowed;box-shadow:none}
.cl-card{background:#fff;border:1px solid #e2e8f0;border-radius:20px;box-shadow:0 16px 40px rgba(15,23,42,.06);overflow:hidden}
.cl-card-head{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:18px 20px;border-bottom:1px solid #e2e8f0;background:linear-gradient(180deg,#ffffff 0%,#f8fafc 100%)}
.cl-card-title{margin:0;font-size:16px;font-weight:800;color:#0f172a}
.cl-card-meta{margin:4px 0 0;font-size:13px;color:#64748b}
.cl-table-wrap{overflow-x:auto}
.cl-table{width:100%;border-collapse:collapse;font-size:13px;min-width:1280px}
.cl-table th{background:#f8fafc;color:#334155;text-align:left;padding:13px 16px;border-bottom:1px solid #e2e8f0;white-space:nowrap;font-size:12px;font-weight:800;letter-spacing:.02em;text-transform:uppercase}
.cl-table td{padding:14px 16px;border-bottom:1px solid #f1f5f9;white-space:nowrap;color:#0f172a;vertical-align:middle}
.cl-row-name{display:flex;flex-direction:column;gap:2px}
.cl-row-name strong{font-size:13px;color:#0f172a}
.cl-row-name span{font-size:12px;color:#64748b}
.cl-empty{padding:36px 20px;text-align:center;color:#475569}
.cl-badge{display:inline-flex;align-items:center;gap:4px;border-radius:999px;padding:5px 10px;font-size:11px;font-weight:800}
.cl-new{background:#dbeafe;color:#1d4ed8}
.cl-regular{background:#dcfce7;color:#166534}
.cl-vip{background:#fef3c7;color:#92400e}
.cl-actions{display:flex;gap:8px}
.cl-ghost{display:inline-flex;align-items:center;justify-content:center;gap:6px;border:1px solid #cbd5e1;background:#fff;color:#0f172a;border-radius:10px;padding:8px 11px;font-size:12px;font-weight:600;cursor:pointer}
.cl-ghost:hover{border-color:#94a3b8;background:#f8fafc}
.cl-pagination{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:14px 18px;background:#fff}
.cl-page-info{font-size:12px;color:#475569}
.cl-page-actions{display:flex;gap:8px}
.cl-sk{height:44px;border-radius:10px;background:linear-gradient(90deg,#e2e8f0 25%,#f8fafc 50%,#e2e8f0 75%);background-size:200% 100%;animation:shimmer 1.5s infinite;margin:8px 16px}
@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
.cl-modal{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:1200;display:flex;align-items:center;justify-content:center;padding:16px}
.cl-modal-card{width:min(100%,920px);max-width:920px;max-height:calc(100vh - 32px);background:#fff;border-radius:18px;border:1px solid #cbd5e1;box-shadow:0 28px 70px rgba(15,23,42,.28);overflow:hidden;display:flex;flex-direction:column}
.cl-modal-h{padding:16px 18px;border-bottom:1px solid #dbeafe;font-weight:800;color:#0f172a}
.cl-modal-b{padding:14px 16px;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:10px;align-items:start;overflow-y:auto;min-height:0}
.cl-section{grid-column:1/-1;margin-top:6px;padding:14px;border:1px solid #e2e8f0;border-radius:16px;background:#f8fafc}
.cl-section h3{margin:0 0 4px;font-size:14px;font-weight:800;color:#0f172a}
.cl-section p{margin:0 0 12px;font-size:12px;color:#64748b}
.cl-section-grid{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:10px}
.cl-modal-f{padding:14px 16px;border-top:1px solid #e5e7eb;display:flex;justify-content:flex-end;gap:8px;flex-shrink:0}
@media(max-width:768px){
  .cl-hero{padding:18px;flex-direction:column}
  .cl-stats{grid-template-columns:1fr}
  .cl-toolbar{padding:14px}
  .cl-search{min-width:100%}
  .cl-card-head,.cl-pagination{padding-left:14px;padding-right:14px}
  .cl-modal-card{max-width:none;width:100vw;height:100vh;border-radius:0}
  .cl-modal-b{grid-template-columns:1fr}
  .cl-section-grid{grid-template-columns:1fr}
}
@media(max-width:520px){
  .cl-title{font-size:20px}
  .cl-subtitle{font-size:13px}
  .cl-modal{padding:0}
  .cl-modal-card{width:100vw;max-width:100vw;min-height:100vh;border-radius:0}
  .cl-modal-h,.cl-modal-b,.cl-modal-f{padding-left:12px;padding-right:12px}
  .cl-modal-f{flex-direction:column-reverse}
  .cl-modal-f .cl-ghost,.cl-modal-f .cl-btn{width:100%}
}
`;

function ratingClass(r) {
  if (r === 'VIP') return 'cl-vip';
  if (r === 'REGULAR') return 'cl-regular';
  return 'cl-new';
}

function CustomerForm({ open, onClose, onSaved, edit }) {
  const { getOptions } = useMasterData(['CUSTOMER_CATEGORY', 'PAYMENT_TERMS']);
  const categoryOptions = getOptions('CUSTOMER_CATEGORY');
  const paymentTermOptions = getOptions('PAYMENT_TERMS');
  const emptyForm = {
    name: '',
    phone: '',
    email: '',
    city: '',
    state: '',
    full_address: '',
    category: '',
    payment_terms: '',
    credit_limit: '',
    shop_address_line1: '',
    shop_address_line2: '',
    shop_city: '',
    shop_state: '',
    shop_pincode: '',
    home_address_line1: '',
    home_address_line2: '',
    home_city: '',
    home_state: '',
    home_pincode: '',
    referred_by_customer_id: '',
    referred_by_name: '',
  };
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [states, setStates] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);

  useEffect(() => {
    if (!open) return;
    setForm({
      ...emptyForm,
      name: edit?.name || '',
      phone: edit?.phone || '',
      email: edit?.email || '',
      city: edit?.shop_city || edit?.city || '',
      state: edit?.shop_state || edit?.state || '',
      full_address: edit?.shop_full_address || edit?.full_address || '',
      category: edit?.category || categoryOptions[0]?.value || 'RETAIL',
      payment_terms: edit?.payment_terms || paymentTermOptions[0]?.value || 'IMMEDIATE',
      credit_limit: edit?.credit_limit ?? '',
      shop_address_line1: edit?.shop_address_line1 || '',
      shop_address_line2: edit?.shop_address_line2 || '',
      shop_city: edit?.shop_city || edit?.city || '',
      shop_state: edit?.shop_state || edit?.state || '',
      shop_pincode: edit?.shop_pincode || '',
      home_address_line1: edit?.home_address_line1 || '',
      home_address_line2: edit?.home_address_line2 || '',
      home_city: edit?.home_city || '',
      home_state: edit?.home_state || '',
      home_pincode: edit?.home_pincode || '',
      referred_by_customer_id: edit?.referred_by_customer_id || '',
      referred_by_name: edit?.referred_by_name || '',
    });
  }, [open, edit, categoryOptions, paymentTermOptions]);

  useEffect(() => {
    if (!open) return;
    let mounted = true;
    api.get('/sales/states')
      .then((res) => {
        if (mounted) setStates(res?.data?.data || []);
      })
      .catch(() => {
        if (mounted) setStates([]);
      });
    api.get('/sales/customers', { params: { page: 1, limit: 200 } })
      .then((res) => {
        if (mounted) {
          const currentId = Number(edit?.id || 0);
          setCustomerOptions((res?.data?.data || []).filter((customer) => Number(customer.id) !== currentId));
        }
      })
      .catch(() => {
        if (mounted) setCustomerOptions([]);
      });
    return () => {
      mounted = false;
    };
  }, [open, edit?.id]);

  if (!open) return null;

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const save = async () => {
    if (!form.name.trim()) return;
    setSaving(true);
    try {
      const payload = {
        ...form,
        referred_by_customer_id: form.referred_by_customer_id ? Number(form.referred_by_customer_id) : null,
        credit_limit: form.credit_limit === '' ? 0 : Number(form.credit_limit),
        city: form.shop_city,
        state: form.shop_state,
        pincode: form.shop_pincode,
        full_address: [
          form.shop_address_line1,
          form.shop_address_line2,
          form.shop_city,
          form.shop_state,
          form.shop_pincode,
        ].filter(Boolean).join(', '),
      };
      if (edit?.id) {
        await api.put(`/sales/customers/${edit.id}`, payload);
      } else {
        await api.post('/sales/customers', payload);
      }
      onSaved?.();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cl-modal" onClick={onClose}>
      <div className="cl-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="cl-modal-h">{edit ? 'Edit Customer' : 'Create Customer'}</div>
        <div className="cl-modal-b">
          <input className="cl-input" placeholder="Name" value={form.name} onChange={(e) => set('name', e.target.value)} />
          <input className="cl-input" placeholder="Phone" value={form.phone} onChange={(e) => set('phone', e.target.value)} />
          <input className="cl-input" placeholder="Email" value={form.email} onChange={(e) => set('email', e.target.value)} />
          <select className="cl-select" value={form.category} onChange={(e) => set('category', e.target.value)}>
            <option value="">Select Category</option>
            {categoryOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label || option.value}</option>
            ))}
          </select>
          <select className="cl-select" value={form.payment_terms} onChange={(e) => set('payment_terms', e.target.value)}>
            <option value="">Select Payment Terms</option>
            {paymentTermOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label || option.value}</option>
            ))}
          </select>
          <input
            className="cl-input"
            type="number"
            min="0"
            step="0.01"
            placeholder="Credit Limit"
            value={form.credit_limit}
            onChange={(e) => set('credit_limit', e.target.value)}
          />
          <div className="cl-section">
            <h3>Referral Details</h3>
            <p>Select an existing customer who referred this customer, or type the referral name manually.</p>
            <div className="cl-section-grid">
              <select
                className="cl-select"
                value={form.referred_by_customer_id}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedCustomer = customerOptions.find((customer) => String(customer.id) === selectedId);
                  set('referred_by_customer_id', selectedId);
                  if (selectedCustomer?.name) {
                    set('referred_by_name', selectedCustomer.name);
                  }
                }}
              >
                <option value="">Select Existing Referral Customer</option>
                {customerOptions.map((customer) => (
                  <option key={customer.id} value={customer.id}>
                    {customer.name}{customer.phone ? ` - ${customer.phone}` : ''}
                  </option>
                ))}
              </select>
              <input
                className="cl-input"
                placeholder="Referral Name"
                value={form.referred_by_name}
                onChange={(e) => set('referred_by_name', e.target.value)}
              />
            </div>
          </div>
          <div className="cl-section">
            <h3>Shop Address</h3>
            <p>Customer business or shop address.</p>
            <div className="cl-section-grid">
              <input className="cl-input" placeholder="Shop Address Line 1" value={form.shop_address_line1} onChange={(e) => { set('shop_address_line1', e.target.value); set('full_address', e.target.value); }} />
              <input className="cl-input" placeholder="Shop Address Line 2" value={form.shop_address_line2} onChange={(e) => set('shop_address_line2', e.target.value)} />
              <input className="cl-input" placeholder="Shop City" value={form.shop_city} onChange={(e) => { set('shop_city', e.target.value); set('city', e.target.value); }} />
              <select className="cl-select" value={form.shop_state} onChange={(e) => { set('shop_state', e.target.value); set('state', e.target.value); }}>
                <option value="">Select Shop State</option>
                {states.map((state) => (
                  <option key={state.id} value={state.name}>{state.name}</option>
                ))}
              </select>
              <input className="cl-input" placeholder="Shop Pincode" value={form.shop_pincode} onChange={(e) => set('shop_pincode', e.target.value)} />
            </div>
          </div>
          <div className="cl-section">
            <h3>Home / Permanent Address</h3>
            <p>Customer residential or permanent address.</p>
            <div className="cl-section-grid">
              <input className="cl-input" placeholder="Home Address Line 1" value={form.home_address_line1} onChange={(e) => set('home_address_line1', e.target.value)} />
              <input className="cl-input" placeholder="Home Address Line 2" value={form.home_address_line2} onChange={(e) => set('home_address_line2', e.target.value)} />
              <input className="cl-input" placeholder="Home City" value={form.home_city} onChange={(e) => set('home_city', e.target.value)} />
              <select className="cl-select" value={form.home_state} onChange={(e) => set('home_state', e.target.value)}>
                <option value="">Select Home State</option>
                {states.map((state) => (
                  <option key={state.id} value={state.name}>{state.name}</option>
                ))}
              </select>
              <input className="cl-input" placeholder="Home Pincode" value={form.home_pincode} onChange={(e) => set('home_pincode', e.target.value)} />
            </div>
          </div>
        </div>
        <div className="cl-modal-f">
          <button className="cl-ghost" onClick={onClose}>Cancel</button>
          <button className="cl-btn" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}

export default function CustomerList({ onViewDetail }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [rating, setRating] = useState('ALL');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const limit = 20;

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit };
      if (debouncedSearch.trim()) params.search = debouncedSearch.trim();
      if (rating !== 'ALL') params.rating = rating;
      const res = await api.get('/sales/customers', { params });
      setRows(res?.data?.data || []);
      setTotal(Number(res?.data?.total || 0));
    } catch {
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, page, rating]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 300);
    return () => clearTimeout(t);
  }, [search]);
  useEffect(() => { setPage(1); }, [rating]);

  const pages = useMemo(() => Math.max(1, Math.ceil(total / limit)), [total]);
  const totalCustomers = useMemo(() => rows.length, [rows.length]);
  const vipCustomers = useMemo(() => rows.filter((row) => row.rating === 'VIP').length, [rows]);
  const currentPageValue = useMemo(
    () => rows.reduce((sum, row) => sum + Number(row.total_order_value || 0), 0),
    [rows]
  );

  return (
    <>
      <style>{S}</style>
      <div className="cl-wrap">
        <div className="cl-hero">
          <div className="cl-hero-copy">
            <div className="cl-eyebrow">Customer Hub</div>
            <h1 className="cl-title">Customers</h1>
            <p className="cl-subtitle">
              Track client relationships, review purchase history, and jump into detailed profiles without leaving the sales workspace.
            </p>
          </div>
          <div className="cl-stats">
            <div className="cl-stat">
              <div className="cl-stat-label">Visible Customers</div>
              <div className="cl-stat-value">{totalCustomers}</div>
            </div>
            <div className="cl-stat">
              <div className="cl-stat-label">VIP Customers</div>
              <div className="cl-stat-value">{vipCustomers}</div>
            </div>
            <div className="cl-stat">
              <div className="cl-stat-label">Page Value</div>
              <div className="cl-stat-value">Rs {currentPageValue.toLocaleString('en-IN')}</div>
            </div>
          </div>
        </div>

        <div className="cl-toolbar">
          <div className="cl-search">
            <Search size={14} style={{ position: 'absolute', left: 10, top: 12, color: '#6b7280' }} />
            <input className="cl-input" style={{ paddingLeft: 30, width: '100%' }} value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by name/email/phone" />
          </div>
          <select className="cl-select" value={rating} onChange={(e) => setRating(e.target.value)}>
            <option value="ALL">All Ratings</option>
            <option value="NEW">NEW</option>
            <option value="REGULAR">REGULAR</option>
            <option value="VIP">VIP</option>
          </select>
          <button className="cl-btn" onClick={() => { setEditRow(null); setModalOpen(true); }}><Plus size={14} />Add Customer</button>
        </div>

        <div className="cl-card">
          <div className="cl-card-head">
            <div>
              <h2 className="cl-card-title">Customer Directory</h2>
              <p className="cl-card-meta">{total.toLocaleString('en-IN')} total customers matched your current filters.</p>
            </div>
          </div>
          <div className="cl-table-wrap">
            <table className="cl-table">
              <thead>
                <tr>
                  <th>Name</th><th>Phone</th><th>Shop Address</th><th>Home Address</th><th>Orders</th><th>Total Value</th><th>Rating</th><th>Last Order</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={9}>{Array.from({ length: 6 }).map((_, i) => <div key={i} className="cl-sk" />)}</td></tr>
                ) : rows.length === 0 ? (
                  <tr><td colSpan={9} className="cl-empty">No customers found</td></tr>
                ) : rows.map((r) => (
                  <tr key={r.id}>
                    <td>
                      <div className="cl-row-name">
                        <strong>{r.name}</strong>
                        <span>{r.email || 'No email added'}</span>
                      </div>
                    </td>
                    <td>{r.phone || '-'}</td>
                    <td>{r.shop_full_address || '-'}</td>
                    <td>{r.home_full_address || '-'}</td>
                    <td>{r.total_orders || 0}</td>
                    <td>Rs {Number(r.total_order_value || 0).toLocaleString('en-IN')}</td>
                    <td><span className={`cl-badge ${ratingClass(r.rating)}`}>{r.rating === 'VIP' ? <Star size={12} /> : null}{r.rating}</span></td>
                    <td>{r.last_order_date || '-'}</td>
                    <td>
                      <div className="cl-actions">
                        <button className="cl-ghost" onClick={() => onViewDetail?.(r.id)}><Eye size={13} style={{ marginRight: 4 }} />View</button>
                        <button className="cl-ghost" onClick={() => { setEditRow(r); setModalOpen(true); }}><Edit3 size={13} style={{ marginRight: 4 }} />Edit</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="cl-pagination">
            <div className="cl-page-info">Page {page} of {pages}</div>
            <div className="cl-page-actions">
              <button className="cl-ghost" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Prev</button>
              <button className="cl-ghost" disabled={page >= pages} onClick={() => setPage((p) => Math.min(pages, p + 1))}>Next</button>
            </div>
          </div>
        </div>
      </div>

      <CustomerForm
        open={modalOpen}
        edit={editRow}
        onClose={() => setModalOpen(false)}
        onSaved={() => { setModalOpen(false); load(); }}
      />
    </>
  );
}
